// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".context-bar.theme--light.v-sheet--outlined{border:none}.context-bar__actions{height:100%}", ""]);
// Exports
module.exports = exports;
